import { __extends } from "tslib";
import * as React from 'react';
import { withRouter } from 'react-router-dom';
export var Boundary = withRouter(/** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: undefined,
        };
        return _this;
    }
    class_1.prototype.componentDidCatch = function (error) {
        var _this = this;
        var history = this.props.history;
        var unlisten = history.listen(function () {
            _this.setState({
                error: undefined,
            });
            unlisten();
        });
        this.setState({
            error: error,
        });
    };
    class_1.prototype.render = function () {
        var error = this.state.error;
        var _a = this.props, children = _a.children, ShowError = _a.ShowError;
        if (error) {
            return React.createElement(ShowError, { error: error });
        }
        return children;
    };
    return class_1;
}(React.Component)));
//# sourceMappingURL=index.js.map